<!--
 * @Description: 鼠标移入图片播放视频 页面
 * @Author: mhf
 * @Date: 2023-09-16 17:28:46
-->
<template>
  <div class="video-container">
    <div
      class="video-wrapper"
      ref="videoWrapper"
      @mouseenter="handleMouseEnter"
      @mouseout="handleEnded"
    >
      <video
        class="video"
        id="videoComp"
        ref="video"
        autoplay
        muted
        v-show="showVideo && videoOrGif === 'video'"
        loop
        :src="videoSrc"
      ></video>

      <img
        class="poster"
        ref="image"
        v-show="showVideo && videoOrGif === 'gif'"
        :src="gifSrc"
      />

      <img class="poster" ref="image" v-if="!showVideo" :src="imgSrc" />
    </div>
  </div>
</template>

<script>
export default {
  name: "hoverShowVideo",
  props: {
    videoOrGif: {
      type: String,
      default: "gif",
    },
    imgSrc: {
      type: String,
      default: require("../../public/img/indexBg/doodles.jpeg"),
    },
    gifSrc: {
      type: String,
      default: require("../../public/img/indexBg/doodles.gif"),
    },
    videoSrc: {
      type: String,
      default: require("../../public/video/doodles.mp4"),
    },
  },
  data() {
    return {
      showVideo: false,
    };
  },
  methods: {
    handleMouseEnter() {
      this.showVideo = true;
    },
    handleEnded() {
      this.showVideo = false;
    },
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #eee;
  overflow: hidden;
}

.video-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video {
  width: 100%;
}

.poster {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>
